
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: String } )
        public Titulo: string;

        @Prop( { type: String } )
        public Valor: string;

        @Prop( { type: String } )
        public Icono: string;

        @Prop( { type: Boolean } )
        public br: boolean;

        @Prop( { type: Boolean } )
        public nomargin: boolean;

    }
